import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = `${API_URL}/api/timers`

const putTimer = (access_token, data) => Axios.put(ENDPOINT, data, {
  headers: { 'Access-Token': access_token },
})

export default {
  putTimer,
}
